import React,{ Component } from 'react';
import { Button, Modal, ModalHeader,ModalBody, ModalFooter } from 'reactstrap';
import * as Icon from 'react-feather';
export default class Confirm extends Component{
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    confirm = () => {
        const { confirm } = this.props;
        confirm();
        this.toggle();
    }

    render = () => {
        const { icon = 'Trash2' } = this.props;
        const IconComponent = Icon[icon];
        return (
            <div>
                <IconComponent style={{padding:5,stroke: "#007bff"}} color="#fff" size={30} onClick={this.toggle}/>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>Confirmation</ModalHeader>
                    <ModalBody>
                        <p>Are you sure that you want to do this ?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.confirm}>Confirm</Button>
                        <Button color="danger" onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Confirm.js